import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { DatasourceBrowser } from "src/containers/DatasourceBrowser";

type DocumentsSearch = {
    tab?: string;
};

export const Route = createFileRoute("/_layout-nosidebar/documents")({
    component: Documents,
    validateSearch: (search: DocumentsSearch & SearchSchemaInput): DocumentsSearch => ({
        tab: search.tab,
    }),
});

function Documents() {
    return <DatasourceBrowser kind="document" />;
}
